import { TFunction } from 'i18next';
import classes from '../DocumentTable.module.scss';

export const getDocumentColumns = (t: TFunction) => [
  {
    title: t('Documents.table.columns.name'),
    dataIndex: 'name',
    key: 'name',
    sorter: true,
    showSorterTooltip: {mouseEnterDelay: 1},
    width: 320,
  },
  {
    title: t('Documents.table.columns.status'),
    dataIndex: 'status',
    key: 'status',
    ellipsis: true,
    showSorterTooltip: {mouseEnterDelay: 1},
    width: 200,
  },
  {
    title: t('Documents.table.columns.chat'),
    dataIndex: 'chats',
    key: 'chats',
    ellipsis: true,
    className: classes.textToCenter,
    width: 80,
  },
  {
    title: t('Documents.table.columns.date'),
    dataIndex: 'upload_at',
    key: 'upload_at',
    sorter: true,
    ellipsis: true,
    showSorterTooltip: {mouseEnterDelay: 1},
    width: 160,
  },
];

export const filtersForStatusColumn = (backendFilters: string[], t: TFunction) =>
  backendFilters.map(key => ({ text: t(`Documents.table.status.${key}`), value: key }));
